module.exports = __webpack_public_path__ + "assets/img/wa-.daa372be.svg";